import { classes } from "./classes.js";

/**
 * `P0-UIK-001`. A native `<select>`, on purpose.
 *
 * 4.6.7 puts the client on a low-end handset over 3G: the platform's own
 * picker opens instantly, works with the keyboard, and costs no JavaScript.
 * A custom dropdown is a listbox to reimplement, an accessibility surface to
 * get wrong, and bytes to ship to somebody paying for them.
 */
export interface SelectOption {
  readonly value: string;
  readonly label: string;
}

export interface SelectProps {
  readonly id: string;
  readonly value: string;
  readonly options: readonly SelectOption[];
  readonly onChange?: (value: string) => void;
  readonly className?: string;
  /** `F-0c`: the selector a spec and a corridor reach the control by. */
  readonly testId?: string;
}

export function Select({ id, value, options, onChange, className, testId }: SelectProps): React.JSX.Element {
  return (
    <select
      id={id}
      value={value}
      onChange={(event) => onChange?.(event.target.value)}
      data-kit="select"
      data-testid={testId}
      className={classes(
        "rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-900",
        className,
      )}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
